import { render } from "./ListFollowing.vue?vue&type=template&id=2afc367e&scoped=true"
import script from "./ListFollowing.vue?vue&type=script&lang=js"
export * from "./ListFollowing.vue?vue&type=script&lang=js"

import "./ListFollowing.vue?vue&type=style&index=0&id=2afc367e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afc367e"]])

export default __exports__